export default __webpack_public_path__ + "static/media/helm_of_the_defiant.efba8503.jpg";